export const getValidUrl = (url: string | undefined): string | undefined => {
  return url && url !== "" ? url : undefined;
};
